var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jr-view"},_vm._l((_vm.list),function(item,index){return _c('van-image',{key:index,attrs:{"width":"100%","fit":"contain","src":item,"show-loading":false}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }